import React from 'react';
export default (function (props) {
  return /*#__PURE__*/React.createElement("div", {
    className: "cloud-ui-search-section"
  }, props.children);
});